import { createContext, useContext, useState, useEffect } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const imgUrl = (img) => (img && img.startsWith("http") ? img : `${API}/media/${img}`);
export const money = (n) => `£${Number(n).toFixed(2)}`;

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("emporium_cart")) || []; } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("emporium_cart", JSON.stringify(items)); }, [items]);

  const add = (p, qty = 1) => setItems((prev) => {
    const e = prev.find((i) => i.id === p.id);
    if (e) return prev.map((i) => i.id === p.id ? { ...i, qty: Math.min(i.qty + qty, i.stock || 999) } : i);
    return [...prev, { id: p.id, name: p.name, price: p.price, image: p.image, stock: p.stock, qty }];
  });
  const setQty = (id, qty) => setItems((prev) => prev.map((i) => i.id === id ? { ...i, qty: Math.max(1, Math.min(qty, i.stock || 999)) } : i));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const count = items.reduce((n, i) => n + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
export const shippingFor = (method, subtotal) =>
  subtotal >= 150 && method === "Standard" ? 0 : (method === "Express" ? 9.95 : 5.95);
